export class SubscribeRateAgreementData {
    constructor(
        public debtNumber: string,
        public spotRateAgreementId: string,
        public channel: Channel,
        public language: string,
        public emailAddress?: string,
        public phoneNumber?: number
    ) {}
}

export enum Channel {
    EMAIL = "EMAIL",
    SMS = "SMS",
}
